// src/app/core/auth/models/auth-user.model.ts
export interface ProspectoProfile {
  id: number;
  nombre: string;
  apellido: string;
  telefono: string | null;
  email: string;
  created_at: string;
}

export interface AuthUser {
  id: number;
  cat_type_user_id: number;
  cat_type_user_name?: string;
  cat_user_id: number;
  perfil_id: number;
  email: string;
  status_id: number;
  status_name?: string;
  created_at: string;
  ultimo_login: string | null;
  // campos comunes
  nombre?: string;
  apellido?: string;
  // datos colaborador (type 1)
  corporate_email?: string;
  phone_number?: string;
  document_type?: string;
  document_number?: string;
  department?: string;
  occupation?: string;
  support_staff_id?: number;
  // datos prospecto (type 3)
  telefono?: string;
  // datos cliente (type 2)
  company_name?: string;
  legal_name?: string;
  nit?: string;
  address?: string;
  representative_email?: string;
  // datos visuales
  imagen?: string;
  perfil?: string;
}

export interface LoginResponse {
  success: number;
  message: string;
  access_token: string;
  token_type: string;
  data: AuthUser;
}

export interface OAuthResponse {
  success: number;
  message: string;
  access_token: string;
  token_type: string;
  is_new_user: boolean;
  data: AuthUser;
}

export enum UserType {
  COLABORADOR = 1,
  CLIENTE = 2,
  PROSPECTO = 3
}

export enum UserStatus {
  ACTIVO = 1,
  INACTIVO = 2,
  BLOQUEADO = 3
}